import cn from 'classnames'
import moment from 'moment'

const AccountStatus = ({
  isDeactivatedAccount,
  deactivatedAt,
  handleReactivatePosAccount,
}) => {
  return (
    <section className="item-settings__section pos-accounts-status">
      <div className="content-wrapper  -no-padding">
        <div className="content-header">Account Status</div>
        <div className="content-wrapper -no-padding">
          <>
            <span
              className={cn('status-dot margin-right-xs', {
                '-active': !isDeactivatedAccount,
                '-inactive': isDeactivatedAccount,
              })}
            ></span>
            <span>
              {!isDeactivatedAccount ? 'Active' : 'Deactivated'}
            </span>
          </>
        </div>
      </div>
      {isDeactivatedAccount && (
        <div className="description text-right padding-bottom-xs">
          Deactivated on{' '}
          {moment(deactivatedAt).format('M/DD/YY HH:mma')}
        </div>
      )}
      {isDeactivatedAccount && (
        <button
          className="btn -outline -btn-background-white"
          type="button"
          onClick={handleReactivatePosAccount}
        >
          Reactivate POS Account
        </button>
      )}
    </section>
  )
}

export default AccountStatus
